<script lang="ts" setup>
import type { SelectableWorkspace } from '~/stores/admin'

const adminStore = useAdminStore()
const { fetchAllAdministeredWorkspaces } = adminStore
const { selectedWorkspace } = storeToRefs(adminStore)
const { showAdminInterface } = storeToRefs(useAuthStore())
const route = useRoute()

const showModal = defineModel<boolean>()
const fetching = ref(false)
const selectedItem = ref<SelectableWorkspace | null>(null)
const allAdministeredWorkspacesOverview = ref<SelectableWorkspace[]>([])

function handleWorkspaceClick(workspace: SelectableWorkspace) {
  selectedItem.value = workspace
}

function closeModal() {
  if (!selectedItem.value && route.path.includes('/admin')) {
    navigateTo('/projects')
    showAdminInterface.value = false
  }
  selectedItem.value = null
  showModal.value = false
}

function confirmSelection() {
  if (selectedItem.value) {
    selectedWorkspace.value = selectedItem.value
    navigateTo(`/admin`)
    showAdminInterface.value = true
    closeModal()
  }
}

onMounted(async () => {
  allAdministeredWorkspacesOverview.value
    = await fetchAllAdministeredWorkspaces(fetching, true)
  selectedItem.value = selectedWorkspace.value
})
</script>

<template>
  <PopupWrapperWithDimOverlay
    v-model="showModal"
    :title="$t('select_workspace')"
    class="!max-w-4xl"
    :close-button="closeModal">
    <template v-if="!fetching">
      <p class="secu-body mt-spacing-sm">
        {{ $t('select_workspace_description') }}
      </p>
      <p class="secu-body-bold mb-spacing-md mt-spacing-lg">
        {{ $t('available_workspaces') }}
      </p>
      <div class="flex max-h-96 flex-col overflow-y-auto">
        <RadioItem
          v-for="workspace in allAdministeredWorkspacesOverview"
          :key="workspace.id"
          :address="workspace.name"
          project-name=""
          :checked="selectedItem === workspace"
          @click="handleWorkspaceClick(workspace)" />
      </div>
      <ModalActions
        class="mt-spacing-lg"
        :confirm-validate="Boolean(selectedItem)"
        @cancel="closeModal"
        @confirm="confirmSelection" />
    </template>
    <template v-else>
      <div class="flex h-52 items-center justify-center">
        <Loading />
      </div>
    </template>
  </PopupWrapperWithDimOverlay>
</template>
